var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlinkingHeart = function SvgBlinkingHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "99px",
    height: "98px",
    viewBox: "0 0 99 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "blinkingheart")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8125,4.3125 C14.2700625,4.3125 12.4662396,6.06110581 11.5,7.1875 C10.5337604,6.06110581 8.7299375,4.3125 7.1875,4.3125 C4.45720833,4.3125 2.875,6.44208901 2.875,9.15247502 C2.875,12.1549917 5.75,15.3333333 11.5,18.6875 C17.25,15.3333333 20.125,12.21875 20.125,9.34375 C20.125,6.63336399 18.5427917,4.3125 15.8125,4.3125 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-26.1%",
    y: "-24.3%",
    width: "152.2%",
    height: "163.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    "in": "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wshlist",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blinkingheart",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DC2626",
    opacity: 0.2,
    cx: 49,
    cy: 49,
    r: 49
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DC2626",
    opacity: 0.2,
    cx: 49,
    cy: 49,
    r: 36.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DC2626",
    opacity: 0.2,
    cx: 49,
    cy: 49,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-General-/-Heart-Border",
    transform: "translate(37.500000, 38.863677)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 23 0 23 23 0 23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 1,
    d: "M15.8125,3.8125 C17.2851523,3.8125 18.4583862,4.416599 19.2819867,5.37746621 C20.1477571,6.38753175 20.625,7.80540107 20.625,9.34375 C20.625,12.3208777 17.7677136,15.6101855 11.7519355,19.1193895 C5.23761794,15.6132956 2.375,12.2608102 2.375,9.15247502 C2.375,7.62018266 2.8479015,6.26377744 3.70257292,5.30456856 C4.52518665,4.38133843 5.70255846,3.8125 7.1875,3.8125 C8.66449477,3.8125 10.3958845,5.2568938 11.5001277,6.43836656 C12.604353,5.25669567 14.3356065,3.8125 15.8125,3.8125 Z",
    fill: "#DC2626",
    fillRule: "evenodd"
  })))))));
};
export default SvgBlinkingHeart;